export default "/images/sky-bg.jpg?c80e48af80b85506281a34e2c09ed494";